import React from 'react';
import { func, bool } from 'prop-types';
import { noop } from 'lodash';
import Samples from '../Samples';
import './style.scss';

const SamplesColumn = ({ onMainSampleTextFieldsRender = noop, onPurchase = noop, isLoading }) => (
    <div className="col-12-xs col-8-md col-9-lg samples-col">
        <Samples
            onMainSampleTextFieldsRender={onMainSampleTextFieldsRender}
            isLoading={isLoading}
            onPurchase={onPurchase}
        />
    </div>
);

SamplesColumn.propTypes = {
    onMainSampleTextFieldsRender: func,
    onPurchase: func,
    isLoading: bool,
};

export default SamplesColumn;
